import axiosInstance, {postData, fetchData} from "./apis";

export const getDeliveryDashboard = async (params) =>
  await axiosInstance.get("/delivery/dashboard", { params });

export const getDeliveryJobs = async (params) =>
  await axiosInstance.get("/delivery/jobs", { params });

export const getDeliveryJob = async (id) =>
  await axiosInstance.get(`/delivery/jobs/${id}`);

export const advanceDeliveryJob = async (id, payload) =>
  await axiosInstance.post(`/delivery/jobs/${id}/advance`, payload);

export const assignDeliveryJob = async (id, payload) =>
  await axiosInstance.post(`/delivery/jobs/${id}/assign`, payload);

export const deliverJob = async (id, payload) =>
  await axiosInstance.post(`/delivery/jobs/${id}/deliver`, payload);

export const completeJob = async (id) =>
  await axiosInstance.post(`/delivery/jobs/${id}/complete`);

export const cancelJob = async (id, payload) =>
  await axiosInstance.post(`/delivery/jobs/${id}/cancel`, payload);

export const getDeliveryRoutes = async (params) =>
  await axiosInstance.get("/delivery/routes", { params });

export const saveDeliveryRoute = async (payload) => {
  if (payload.id) {
    const { id, ...rest } = payload;
    return axiosInstance.put(`/delivery/routes/${id}`, rest);
  }
  return axiosInstance.post("/delivery/routes", payload);
};

export const deleteDeliveryRoute = async (id) =>
  await axiosInstance.delete(`/delivery/routes/${id}`);

export const getDeliveryUsers = async () =>
  await axiosInstance.get("/delivery/users");

export const addDeliveryUser = async (payload) =>
  await axiosInstance.post("/delivery/users", payload);

export const removeDeliveryUser = async (userId, roleType) =>
  await axiosInstance.delete(`/delivery/users/${userId}/role/${roleType}`);

export const getBranchUsers = async () =>
  await axiosInstance.get("/delivery/branch-users");

export const assignRouteUser = async (payload) =>
  await axiosInstance.post("/hrpayroll/save-route-assignment", payload);

export const previewAutoDeliveryRoutesApi = (payload) =>
  postData("delivery/preview-auto-delivery-routes", payload);

export const generateAutoDeliveryRoutesApi = (payload) =>
  postData("/delivery/generate-auto-delivery-routes", payload);

export const getWorkRoutesApi = () => postData("/delivery/get-work-routes");

export const getDeliveryRouteActiveExecutionsApi = (payload) =>
  postData("/delivery/get-route-active-execution-count", payload);

export const getMyDeliveryRoute = (payload) =>
  postData("/delivery/get-my-route", payload);


export const deleteDeliveryRouteArea = (payload) =>
  postData("/delivery/delete-route-area", payload);

export const saveDeliveryRouteArea = (payload) =>
  postData("/delivery/save-route-area", payload);

export const getDeliveryRouteAreas = (payload) =>
  postData("/delivery/get-route-areas", payload);

export const saveDeliveryRoutePointApi = (payload) =>
  postData("/delivery/save-route-point", payload);

export const getDeliveryRoutePointsApi = (payload) =>
  postData("/delivery/get-route-points", payload);

export const deleteDeliveryRoutePointApi = (payload) =>
  postData("/delivery/delete-route-point", payload);

export const saveDeliveryRouteApi = (payload) =>
  postData("/delivery/save-route", payload);

export const getDeliveryRoutesApi = (payload) =>
  postData("/delivery/get-routes", payload);

export const deleteDeliveryRouteApi = (payload) =>
  postData("/delivery/delete-route", payload);

export const saveDeliveryRouteAssignmentApi = (payload) =>
  postData("/delivery/save-route-assignment", payload);

export const getDeliveryRoutesAssignmentsApi = (payload) =>
  postData("/delivery/get-route-assignments", payload);

export const deleteDeliveryRouteAssignmentApi = (payload) =>
  postData("/delivery/delete-route-assignment", payload);

export const getActiveDeliveryRouteSession = (payload) =>
  postData("/delivery/get-active-route-session", payload);

export const arriveDeliveryRoutePointApi = (payload) =>
  postData("/delivery/arrive-route-point", payload);

export const completeDeliveryRoutePointApi = (payload) =>
  postData("/delivery/complete-route-point", payload);

export const completeDeliveryRouteSessionApi = (payload) =>
  postData("/delivery/complete-route-session", payload);

export const updateDeliveryLiveLocation = (payload) =>
  postData("/delivery/update-live-location", payload);

export const startDeliveryRouteSessionApi = (payload) =>
  postData("/delivery/start-route-session", payload);